import { getDeepestString } from 'utils/getReactNodeLength'
import CIMSLink from '../../../CIMSLink'
import HelpIcon from '../../../HelpIcon'
import ProjectLink from '../../../ProjectLink'
import { CIMSColumn } from '../../CIMSColumn/types'

export function createBaseColumn<T>({
  link,
  help,
  ...rest
}: Pick<CIMSColumn<T>, 'link' | 'help' | 'title'>) {
  // resolve title
  let title = rest.title
  if (typeof link === 'string')
    title = (
      <CIMSLink external href={link}>
        {title}
      </CIMSLink>
    )
  else if (link) title = <ProjectLink item={link}>{title}</ProjectLink>
  title = <HelpIcon text={help}>{title}</HelpIcon>

  let titleKey = getDeepestString(title)
  if (titleKey === '') titleKey = crypto.randomUUID()

  return { title, showSorterTooltip: false, key: titleKey }
}
